/**
 * Códigos e URLs FHIR usados no cálculo de franquia de mensagens CRM,
 * alinhados ao legado (`CRMQuickStats` / `CRMContractContext`).
 */

/** Task de envio em lote pelo CRM (FluxZap). */
export const CRM_TASK_BATCH_NOTIFICATION_CODE = "CRM_BATCH_NOTIFICATION";
export const CRM_TASK_BATCH_NOTIFICATION_CODE_FALLBACK = "BATCH_NOTIFICATION";

/** Saída da Task: quantidade enviada com sucesso (somamos para "Enviadas"). */
export const CRM_TASK_OUTPUT_SUCCESS_COUNT_CODE = "SUCCESS_COUNT";
/** Entrada da Task: quantidade solicitada no lote. */
export const CRM_TASK_INPUT_REQUESTED_COUNT_CODE = "REQUESTED_COUNT";
/** Saída da Task: quantidade não enviada (ex.: notificação desabilitada). */
export const CRM_TASK_OUTPUT_SKIPPED_COUNT_CODE = "SKIPPED_COUNT";
/** Saída da Task: total processado no lote. */
export const CRM_TASK_OUTPUT_TOTAL_PROCESSED_CODE = "TOTAL_PROCESSED";

/** URL da extensão em PaymentNotice que indica créditos comprados. */
export const PURCHASED_CREDITS_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/purchased-credits";

/** Sub-extensão: quantidade de créditos no pacote. */
export const PURCHASED_CREDITS_QUANTITY_EXTENSION_URL = "quantity";
